import { isEmpty } from "Util/isEmpty";
import { searchStringFrom } from "Util/searchStringFrom";

import { Nullable } from "./Nullable";

export type TextValue = {
    text: string
    searchStrings: {
        text: string
    }
}

export function textValueFrom(text: Nullable<string>, allowEmpty?: false): Nullable<TextValue>
export function textValueFrom(text: string, allowEmpty?: false): Nullable<TextValue>
export function textValueFrom(text: string, allowEmpty: true): TextValue
export function textValueFrom(text: Nullable<string>, allowEmpty?: boolean): Nullable<TextValue> {
    if (isEmpty(text) && !(allowEmpty && (typeof text === 'string'))) {
        return null
    }
    return {
        text,
        searchStrings: {
            text: searchStringFrom(text),
        },
    }
}
